<template>
  <q-page class="q-pa-md">
    <!-- Main Container -->
    <q-card flat class="q-px-md q-py-lg">

      <!-- Title Bar -->
      <div class="row items-center justify-left q-mb-lg">
        <div class="col text-h6 mr-sm q-pa-sm bg-grey-1 text-bold">{{ selectedReport.name || "Select a Report" }}</div>
        <div class="col q-pa-sm q-pl-lg">
          <q-btn
            v-if="selectedReport.href"
            label="Generate Report"
            color="primary"
            dense
            @click="generateReport"
          />
        </div>
      </div>

      <div class="row q-col-gutter-lg">
        <!-- Report Topic Section -->
        <div class="col-12 col-md-4">
          <q-card bordered class="q-pa-md">
            <q-card-section>
              <div class="text-center text-h6 text-bold">Report Topic</div>
            </q-card-section>
            <q-list>
              <q-expansion-item label="Producer" expand-separator>
                <!--<q-item clickable @click="selectReport('Producer Summary', '/reports/producer_summary')">-->
                  <!--<q-item-section class="text-primary">Producer Summary</q-item-section>-->
                <!--</q-item>-->
                <q-item clickable @click="selectReport('Producer Statement', '/reports/producer_statement')">
                  <q-item-section class="text-primary">Producer Statement</q-item-section>
                </q-item>
              </q-expansion-item>

              <q-expansion-item label="Fields" expand-separator>
                <!--<q-item clickable @click="selectReport('Field Summary', '/reports/field_summary')">-->
                  <!--<q-item-section class="text-primary">Field Summary</q-item-section>-->
                <!--</q-item>-->
                <q-item clickable @click="selectReport('Field Report', '/reports/field_report')">
                  <q-item-section class="text-primary">Field Report</q-item-section>
                </q-item>
              </q-expansion-item>

              <q-expansion-item label="Bag/Pit" expand-separator>
                <!--<q-item clickable @click="selectReport('Bag/Pit Summary', '/reports/bag_pit_summary')">-->
                  <!--<q-item-section class="text-primary">Bag/Pit Summary</q-item-section>-->
                <!--</q-item>-->
                <q-item clickable @click="selectReport('Bag/Pit Report', '/reports/bag_pit_report')">
                  <q-item-section class="text-primary">Bag/Pit Report</q-item-section>
                </q-item>
              </q-expansion-item>

              <q-expansion-item label="Hauler" expand-separator>
                <!--<q-item clickable @click="selectReport('Hauler Summary', '/reports/hauler_summary')">-->
                  <!--<q-item-section class="text-primary">Hauler Summary</q-item-section>-->
                <!--</q-item>-->
                <q-item clickable @click="selectReport('Hauler Statement', '/reports/hauler_statement')">
                  <q-item-section class="text-primary">Hauler Statement</q-item-section>
                </q-item>
              </q-expansion-item>

              <q-expansion-item label="Customers" expand-separator>
                <!--<q-item clickable @click="selectReport('Customer Summary', '/reports/customer_summary')">-->
                  <!--<q-item-section class="text-primary">Customer Summary</q-item-section>-->
                <!--</q-item>-->
                <q-item clickable @click="selectReport('Customer Statement', '/reports/customer_statement')">
                  <q-item-section class="text-primary">Customer Statement</q-item-section>
                </q-item>
                <q-item clickable @click="selectReport('Customer Statement With Miles', '/reports/customer_statement_with_miles')">
                  <q-item-section class="text-primary">Customer Statement With Miles</q-item-section>
                </q-item>
              </q-expansion-item>

              <q-expansion-item label="Feedmill" expand-separator>
                <q-item clickable @click="selectReport('Feedmill Customer Statement', '/reports/feedmill_customer_statement')">
                  <q-item-section class="text-primary">Feedmill Customer Statement</q-item-section>
                </q-item>
                <q-item clickable @click="selectReport('Feedmill Ticket Summary', '/reports/feedmill_ticket_summary')">
                  <q-item-section class="text-primary">Feedmill Ticket Summary</q-item-section>
                </q-item>
              </q-expansion-item>

              <q-expansion-item label="Delivery" expand-separator>
                <q-item clickable @click="selectReport('Delivery Statement', '/reports/delivery_statement')">
                  <q-item-section class="text-primary">Delivery Statement</q-item-section>
                </q-item>
              </q-expansion-item>

              <q-expansion-item label="Driver" expand-separator>
                <q-item clickable @click="selectReport('Driver Ticket Statement', '/reports/driver_ticket_statement')">
                  <q-item-section class="text-primary">Driver Ticket Statement</q-item-section>
                </q-item>
              </q-expansion-item>
            </q-list>
          </q-card>
        </div>

        <!-- Filters Section -->
        <div class="col-12 col-md-8">
          <q-card bordered class="q-pa-md">
            <q-card-section>
              <div class="text-center text-h6 text-bold">Filters</div>
            </q-card-section>
            <q-form>
              <!-- Date Range Picker -->
              <div class="q-mb-md">
                <q-input
                  filled
                  :model-value="displayDateRangeFilter"
                  label="Date Range"
                  dense
                  readonly
                  hide-bottom-space
                >
                  <template v-slot:append>
                    <div class="clickable-text">
                      <q-icon name="event" size="md" color="primary" class="cursor-pointer" />
                    </div>

                    <q-popup-proxy v-model="showFilterDatePicker" transition-show="scale" transition-hide="scale">
                      <q-date
                        v-model="filters.dateRange"
                        range
                        :options="restrictDates"
                        mask="YYYY-MM-DD"
                        class="q-pa-md"
                      >
                        <div class="row items-center justify-end q-gutter-sm">
                          <q-btn label="Clear" color="primary" @click="filters.dateRange = null" />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </template>
                </q-input>
              </div>
              <!-- Bag/Pit Filter -->
              <div class="q-mb-md">
                <q-select
                  v-model="filters.bagPit"
                  :options="selectOptions.bagPit"
                  option-value="value"
                  option-label="label"
                  label="Bag/Pit"
                  filled
                  dense
                  emit-value
                  map-options
                  clearable
                />
              </div>

              <!-- Crop Filter -->
              <div class="q-mb-md">
                <q-select
                  v-model="filters.crop"
                  :options="selectOptions.crop"
                  option-value="value"
                  option-label="label"
                  label="Crop"
                  filled
                  dense
                  emit-value
                  map-options
                  clearable
                />
              </div>

              <!-- Customer Filter -->
              <div class="q-mb-md">
                <q-select
                  v-model="filters.customer"
                  :options="selectOptions.customer"
                  option-value="value"
                  option-label="label"
                  label="Customer"
                  filled
                  dense
                  emit-value
                  map-options
                  clearable
                />
              </div>

              <!-- Driver Filter -->
              <div class="q-mb-md">
                <q-select
                  v-model="filters.driver"
                  :options="selectOptions.driver"
                  option-value="value"
                  option-label="label"
                  label="Driver"
                  filled
                  dense
                  emit-value
                  map-options
                  clearable
                />
              </div>

              <!-- Feed Filter -->
              <div class="q-mb-md">
                <q-select
                  v-model="filters.feed"
                  :options="selectOptions.feed"
                  option-value="value"
                  option-label="label"
                  label="Feed"
                  filled
                  dense
                  emit-value
                  map-options
                  clearable
                />
              </div>

              <!-- Feedmill Filter -->
              <div class="q-mb-md">
                <q-select
                  v-model="filters.feedmill"
                  :options="selectOptions.feedmill"
                  option-value="value"
                  option-label="label"
                  label="Feedmill"
                  filled
                  dense
                  emit-value
                  map-options
                  clearable
                />
              </div>

              <!-- Field Filter -->
              <div class="q-mb-md">
                <q-select
                  v-model="filters.field"
                  :options="selectOptions.field"
                  option-value="value"
                  option-label="label"
                  label="Field"
                  filled
                  dense
                  emit-value
                  map-options
                  clearable
                />
              </div>

              <!-- Hauler Filter -->
              <div class="q-mb-md">
                <q-select
                  v-model="filters.hauler"
                  :options="selectOptions.hauler"
                  option-value="value"
                  option-label="label"
                  label="Hauler"
                  filled
                  dense
                  emit-value
                  map-options
                  clearable
                />
              </div>

              <!-- Producer Filter -->
              <div class="q-mb-md">
                <q-select
                  v-model="filters.producer"
                  :options="selectOptions.producer"
                  option-value="value"
                  option-label="label"
                  label="Producer"
                  filled
                  dense
                  emit-value
                  map-options
                  clearable
                />
              </div>

            </q-form>
          </q-card>
        </div>
      </div>
    </q-card>
  </q-page>
</template>

<script>
import axios from "axios";
import { watch } from "vue";
import { selectedYear } from "@/store/store";

export default {
  name: "ReportPage",
  data() {
    return {
      showFilterDatePicker: false,
      selectedReport: {
        name: "",
        to: "",
      },
      filters: {
        dateRange: null,
        bagPit: null,
        crop: null,
        customer: null,
        driver: null,
        feed: null,
        field: null,
        hauler: null,
        producer: null,
        feedmill: null,
      },
      selectOptions: {
        bagPit: [],
        crop: [],
        customer: [],
        driver: [],
        feed: [],
        field: [],
        hauler: [],
        producer: [],
        feedmill: [],
      },
      errors: {
        dateRange: null,
        bagPit: null,
        crop: null,
        customer: null,
        driver: null,
        feed: null,
        field: null,
        hauler: null,
        producer: null,
        feedmill: null,
      },
    };
  },
  computed: {
    displayDateRangeFilter() {
      if (!this.filters.dateRange) {
        return "";
      }

      const { from, to } = this.filters.dateRange;

      if (from && to) {
        if (from === to) {
          return from;
        }
        return `${from} - ${to}`;
      }

      if (from && !to) {
        return from;
      }

      return "";
    },
  },
  setup() {
    const restrictDates = (date) => {
      let year = selectedYear.value;
      const start = `${year}/01/01`;
      const end = `${year}/12/31`;
      return date >= start && date <= end;
    };

    return {
      restrictDates,
    };
  },
  created() {
    watch(
      () => selectedYear.value,
      () => {
        this.filters.dateRange = null;
      }
    );

    this.fetchSelectOptions();
  },
  methods: {
    async fetchSelectOptions() {
      const apiEndpoints = {
        bagPit: "/api/v1/customer_bag_pit/customer_bag_pits/",
        crop: "/api/v1/crop/crops/",
        customer: "/api/v1/customer/customers/",
        driver: "/api/v1/driver/drivers/",
        feed: "/api/v1/feed/feeds/",
        field: "/api/v1/field/fields/",
        hauler: "/api/v1/hauler/haulers/",
        producer: "/api/v1/producer/producers/",
        feedmill: "/api/v1/feedmill/feedmills/",
      };

      const displayFields = {
        bagPit: "name",
        crop: "crop",
        customer: "name",
        driver: "name",
        feed: "name",
        field: "name",
        hauler: "name",
        producer: "name",
        feedmill: "name",
      };

      for (const [key, url] of Object.entries(apiEndpoints)) {
        try {
          const response = await axios.get(url);

          this.selectOptions[key] = response.data.map((item) => {
            if (key === "bagPit") {
              return {
                value: item.id,
                label: item.customer_id?.name ? `${item.customer_id.name} - ${item.name}` : item.name,
              };
            } else {
              const displayField = displayFields[key];
              return {
                value: item.id,
                label: item[displayField],
              };
            }
          });
        } catch (error) {
          console.error(`Failed to fetch data for ${key}:`, error);
        }
      }
    },
    selectReport(name, href) {
      this.selectedReport = { name, href };
    },
    generateReport() {
      if (!this.selectedReport.href) return;

      const queryParams = Object.entries(this.filters)
        .filter(([, value]) => value !== null && value !== "")
        .map(([key, value]) => {
          if (key === "dateRange" && value.from && value.to) {
            return `date_from=${encodeURIComponent(value.from)}&date_to=${encodeURIComponent(value.to)}`;
          }
          return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        });

      // Add selectedYear to query parameters
      if (selectedYear.value) {
        queryParams.push(`selectedYear=${encodeURIComponent(selectedYear.value)}`);
      } else {
        console.error("Selected year is missing.");
        return;
      }

      const fullUrl = queryParams.length ? `${this.selectedReport.href}?${queryParams.join("&")}` : this.selectedReport.href;
      window.location.href = fullUrl;
    },
  },
};
</script>
